import waterfallUrl from "/imgs/intelligence_wordart/waterfall_small.jpg";
import snowPlateauUrl from "/imgs/intelligence_wordart/snow_plateau.jpg";
import forestUrl from "/imgs/intelligence_wordart/forest.jpg";
import skyUrl from "/imgs/intelligence_wordart/sky.jpg";
import chineseBuildingUrl from "/imgs/intelligence_wordart/chinese_building.jpg";
import cartoonUrl from "/imgs/intelligence_wordart/cartoon.jpg";
import legoUrl from "/imgs/intelligence_wordart/lego.jpg";
import flowerUrl from "/imgs/intelligence_wordart/flower.jpg";
import acrylicUrl from "/imgs/intelligence_wordart/acrylic.jpg";
import marbleUrl from "/imgs/intelligence_wordart/marble.jpg";
import feltUrl from "/imgs/intelligence_wordart/felt.jpg";
import oilPaintingUrl from "/imgs/intelligence_wordart/oil_painting.jpg";
import watercolorPaintingUrl from "/imgs/intelligence_wordart/watercolor_painting.jpg";
import chinesePaintingUrl from "/imgs/intelligence_wordart/chinese_painting.jpg";
import claborateStylePaintingUrl from "/imgs/intelligence_wordart/claborate_style_painting.jpg";
import cityNightUrl from "/imgs/intelligence_wordart/city_night.jpg";
import mountainLakeUrl from "/imgs/intelligence_wordart/mountain_lake.jpg";
import autumnLeavesUrl from "/imgs/intelligence_wordart/autumn_leaves.jpg";
import greenDragonUrl from "/imgs/intelligence_wordart/green_dragon.jpg";
import redDragonUrl from "/imgs/intelligence_wordart/red_dragon.jpg";
import materialUrl from "/imgs/intelligence_wordart/material.jpg";
import sceneUrl from "/imgs/intelligence_wordart/scene.jpg";
import lightingUrl from "/imgs/intelligence_wordart/lighting.jpg";

import largeWaterfallUrl from "/imgs/intelligence_wordart/waterfall_large.jpg";
import largeSnowPlateauUrl from "/imgs/intelligence_wordart/snow_plateau_large.jpg";
import largeForestUrl from "/imgs/intelligence_wordart/forest_large.jpg";
import largeSkyUrl from "/imgs/intelligence_wordart/sky_large.jpg";
import largeChineseBuildingUrl from "/imgs/intelligence_wordart/chinese_building_large.jpg";
import largeCartoonUrl from "/imgs/intelligence_wordart/cartoon_large.jpg";
import largeLegoUrl from "/imgs/intelligence_wordart/lego_large.jpg";
import largeFlowerUrl from "/imgs/intelligence_wordart/flower_large.jpg";
import largeAcrylicUrl from "/imgs/intelligence_wordart/acrylic_large.jpg";
import largeMarbleUrl from "/imgs/intelligence_wordart/marble_large.jpg";
import largeFeltUrl from "/imgs/intelligence_wordart/felt_large.jpg";
import largeOilPaintingUrl from "/imgs/intelligence_wordart/oil_painting_large.jpg";
import largeWatercolorPaintingUrl from "/imgs/intelligence_wordart/watercolor_painting_large.jpg";
import largeChinesePaintingUrl from "/imgs/intelligence_wordart/chinese_painting_large.jpg";
import largeClaborateStylePaintingUrl from "/imgs/intelligence_wordart/claborate_style_painting_large.jpg";
import largeCityNightUrl from "/imgs/intelligence_wordart/city_night_large.jpg";
import largeMountainLakeUrl from "/imgs/intelligence_wordart/mountain_lake_large.jpg";
import largeAutumnLeavesUrl from "/imgs/intelligence_wordart/autumn_leaves_large.jpg";
import largeGreenDragonUrl from "/imgs/intelligence_wordart/green_dragon_large.jpg";
import largeRedDragonUrl from "/imgs/intelligence_wordart/red_dragon_large.jpg";
import largeMaterialUrl from "/imgs/intelligence_wordart/material_large.jpg";
import largeSceneUrl from "/imgs/intelligence_wordart/scene_large.jpg";
import largeLightUrl from "/imgs/intelligence_wordart/lighting_large.jpg";

export enum Mode {
  SYSTEM = "system", //系统预设
  CUSTOM = "custom", //自定义
}

export enum Background {
  GENERATE = "generate", //生成背景
  LUCENT = "lucent", //透明背景
}

export enum FontStyle {
  Waterfall = "waterfall",
  SnowPlateau = "snow_plateau",
  Forest = "forest",
  Sky = "sky",
  ChineseBuilding = "chinese_building",
  Cartoon = "cartoon",
  Lego = "lego",
  Flower = "flower",
  Acrylic = "acrylic",
  Marble = "marble",
  Felt = "felt",
  OilPainting = "oil_painting",
  WatercolorPainting = "watercolor_painting",
  ChinesePainting = "chinese_painting",
  ClaborateStylePainting = "claborate_style_painting",
  CityNight = "city_night",
  MountainLake = "mountain_lake",
  AutumnLeaves = "autumn_leaves",
  Material = "material",
  Scene = "scene",
  Lighting = "lighting",
  GreenDragon = "green_dragon",
  RedDragon = "red_dragon",
}

export const customizeImgStyleMap = {
  [FontStyle.Waterfall]: "流水瀑布",
  [FontStyle.SnowPlateau]: "雪域高原",
  [FontStyle.Forest]: "原始森林",
  [FontStyle.Sky]: "太空遨游",
  [FontStyle.ChineseBuilding]: "国风建筑",
  [FontStyle.Cartoon]: "奇幻卡通",
  [FontStyle.Lego]: "乐高积木",
  [FontStyle.Flower]: "繁花盛开",
  [FontStyle.Acrylic]: "亚克力",
  [FontStyle.Marble]: "大理石",
  [FontStyle.Felt]: "绒绒毛毡",
  [FontStyle.OilPainting]: "复古油画",
  [FontStyle.WatercolorPainting]: "水彩",
  [FontStyle.ChinesePainting]: "中国画",
  [FontStyle.ClaborateStylePainting]: "工笔画",
  [FontStyle.CityNight]: "城市夜景",
  [FontStyle.MountainLake]: "湖光山色",
  [FontStyle.AutumnLeaves]: "秋日落叶",
  [FontStyle.GreenDragon]: "青龙献瑞",
  [FontStyle.RedDragon]: "赤龙呈祥",

  [FontStyle.Material]: "立体材质",
  [FontStyle.Scene]: "场景融合",
  [FontStyle.Lighting]: "光影特效",
};

export const systemPresetsImgStyleOptions = [
  {
    url: cityNightUrl,
    largeImgUrl: largeCityNightUrl,
    styleName: "城市夜景",
    style: FontStyle.CityNight,
    selected: true,
  },
  {
    url: legoUrl,
    largeImgUrl: largeLegoUrl,
    styleName: "乐高积木",
    style: FontStyle.Lego,
    selected: false,
  },
  {
    url: waterfallUrl,
    largeImgUrl: largeWaterfallUrl,
    styleName: "流水瀑布",
    style: FontStyle.Waterfall,
    selected: false,
  },
  {
    url: snowPlateauUrl,
    largeImgUrl: largeSnowPlateauUrl,
    styleName: "雪域高原",
    style: FontStyle.SnowPlateau,
    selected: false,
  },
  {
    url: forestUrl,
    largeImgUrl: largeForestUrl,
    styleName: "原始森林",
    style: FontStyle.Forest,
    selected: false,
  },
  {
    url: skyUrl,
    largeImgUrl: largeSkyUrl,
    styleName: "太空遨游",
    style: FontStyle.Sky,
    selected: false,
  },
  {
    url: chineseBuildingUrl,
    largeImgUrl: largeChineseBuildingUrl,
    styleName: "国风建筑",
    style: FontStyle.ChineseBuilding,
    selected: false,
  },
  {
    url: cartoonUrl,
    largeImgUrl: largeCartoonUrl,
    styleName: "奇幻卡通",
    style: FontStyle.Cartoon,
    selected: false,
  },
  {
    url: flowerUrl,
    largeImgUrl: largeFlowerUrl,
    styleName: "繁花盛开",
    style: FontStyle.Flower,
    selected: false,
  },
  {
    url: acrylicUrl,
    largeImgUrl: largeAcrylicUrl,
    styleName: "亚克力",
    style: FontStyle.Acrylic,
    selected: false,
  },
  {
    url: marbleUrl,
    largeImgUrl: largeMarbleUrl,
    styleName: "大理石",
    style: FontStyle.Marble,
    selected: false,
  },
  {
    url: feltUrl,
    largeImgUrl: largeFeltUrl,
    styleName: "绒绒毛毡",
    style: FontStyle.Felt,
    selected: false,
  },
  {
    url: oilPaintingUrl,
    largeImgUrl: largeOilPaintingUrl,
    styleName: "复古油画",
    style: FontStyle.OilPainting,
    selected: false,
  },
  {
    url: watercolorPaintingUrl,
    largeImgUrl: largeWatercolorPaintingUrl,
    styleName: "水彩",
    style: FontStyle.WatercolorPainting,
    selected: false,
  },
  {
    url: chinesePaintingUrl,
    largeImgUrl: largeChinesePaintingUrl,
    styleName: "中国画",
    style: FontStyle.ChinesePainting,
    selected: false,
  },
  {
    url: claborateStylePaintingUrl,
    largeImgUrl: largeClaborateStylePaintingUrl,
    styleName: "工笔画",
    style: FontStyle.ClaborateStylePainting,
    selected: false,
  },
  {
    url: mountainLakeUrl,
    largeImgUrl: largeMountainLakeUrl,
    styleName: "湖光山色",
    style: FontStyle.MountainLake,
    selected: false,
  },
  {
    url: autumnLeavesUrl,
    largeImgUrl: largeAutumnLeavesUrl,
    styleName: "秋日落叶",
    style: FontStyle.AutumnLeaves,
    selected: false,
  },
  {
    url: greenDragonUrl,
    largeImgUrl: largeGreenDragonUrl,
    styleName: "青龙献瑞",
    style: FontStyle.GreenDragon,
    selected: false,
  },
  {
    url: redDragonUrl,
    largeImgUrl: largeRedDragonUrl,
    styleName: "赤龙呈祥",
    style: FontStyle.RedDragon,
    selected: false,
  },
];

export const customizeImgStyleOptions = [
  {
    url: materialUrl,
    largeImgUrl: largeMaterialUrl,
    styleName: "立体材质",
    style: FontStyle.Material,
    selected: true,
  },
  {
    url: sceneUrl,
    largeImgUrl: largeSceneUrl,
    styleName: "场景融合",
    style: FontStyle.Scene,
    selected: false,
  },
  {
    url: lightingUrl,
    largeImgUrl: largeLightUrl,
    styleName: "光影特效",
    style: FontStyle.Lighting,
    selected: false,
  },
];

export const letterOptions = [
  {
    label: "阿里妈妈东方大楷",
    value: "dongfangdakai",
  },
  {
    label: "阿里巴巴普惠体",
    value: "puhuiti_m",
  },
  {
    label: "阿里妈妈数黑体",
    value: "shuheiti",
  },
  {
    label: "钉钉进步体",
    value: "jinbuti",
  },
  {
    label: "站酷酷黑体",
    value: "kuheiti",
  },
  {
    label: "站酷快乐体",
    value: "kuaileti",
  },
  {
    label: "站酷文艺体",
    value: "wenyiti",
  },
  {
    label: "站酷小薇LOGO体",
    value: "logoti",
  },
  {
    label: "站酷仓耳渔阳体",
    value: "cangeryuyangti_m",
  },
  {
    label: "思源宋体",
    value: "siyuansongti_b",
  },
  {
    label: "思源黑体",
    value: "siyuanheiti_m",
  },
  {
    label: "方正楷体",
    value: "fangzhengkaiti",
  },
];
